"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const requestAdapter_1 = __importDefault(require("../../utils/requestAdapter"));
class AeternityService {
    constructor(nodeUrls, compilerUrls, contractBytecode) {
        this._nodeUrls = [];
        this._compilerUrls = [];
        this._contractBytecode = "";
        this.requestWrapper = requestAdapter_1.default;
        /**
         * Function provides retry mechanism if node from the array is failing to respond
         * @param apiUrls
         */
        this.requestApi = (apiUrls) => {
            let currentUrl = apiUrls[0];
            const requestWithRetry = (config) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                let response;
                try {
                    response = yield this.requestWrapper(Object.assign(Object.assign({}, config), { url: `${currentUrl}${config.url}` }));
                }
                catch (e) {
                    const status = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status;
                    /**
                     * Consider 400 and 404 as valid error codes.
                     * Otherwise, switch to the next Aeternity node and retry
                     */
                    if (status === 400 || status === 404) {
                        throw e;
                    }
                    else {
                        const currentUrlIndex = apiUrls.indexOf(currentUrl);
                        const nextUrl = apiUrls[currentUrlIndex + 1];
                        if (nextUrl) {
                            currentUrl = nextUrl;
                            return yield requestWithRetry(config);
                        }
                        else {
                            throw e;
                        }
                    }
                }
                return response;
            });
            return requestWithRetry;
        };
        if (!(nodeUrls === null || nodeUrls === void 0 ? void 0 : nodeUrls.length)) {
            throw new Error("Invalid node URLs");
        }
        if (!(compilerUrls === null || compilerUrls === void 0 ? void 0 : compilerUrls.length)) {
            throw new Error("Invalid compiler URLs");
        }
        if (!contractBytecode) {
            throw new Error("Aeternity contract bytecode not defined");
        }
        this._nodeUrls = typeof nodeUrls === "string" ? [nodeUrls] : nodeUrls;
        this._compilerUrls =
            typeof compilerUrls === "string" ? [compilerUrls] : compilerUrls;
        this._contractBytecode = contractBytecode;
        this.requestNode = this.requestApi(this._nodeUrls);
        this.requestCompiler = this.requestApi(this._compilerUrls);
    }
    getTxDataByHash(hash) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = (yield this.requestNode({
                url: `/v2/transactions/${hash}`,
            }));
            return {
                hash: data.hash,
                blockHeight: data.block_height,
                tx: {
                    callData: data.tx.call_data,
                },
                blockHash: data.block_hash,
            };
        });
    }
    decodeContractCallData(callData) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = (yield this.requestCompiler({
                url: `/decode-calldata/bytecode/`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    calldata: callData,
                    bytecode: this._contractBytecode,
                },
            }));
            return {
                key: (_c = (_b = (_a = data.arguments[0]) === null || _a === void 0 ? void 0 : _a.value[0]) === null || _b === void 0 ? void 0 : _b.key) === null || _c === void 0 ? void 0 : _c.value,
                value: (_f = (_e = (_d = data.arguments[0]) === null || _d === void 0 ? void 0 : _d.value[0]) === null || _e === void 0 ? void 0 : _e.val) === null || _f === void 0 ? void 0 : _f.value,
            };
        });
    }
    getMicroBlock(hash) {
        return __awaiter(this, void 0, void 0, function* () {
            const { time, height } = yield this.requestNode({
                url: `/v2/micro-blocks/hash/${hash}/header`,
            }).then(({ data }) => data);
            return {
                height,
                time,
                hash,
            };
        });
    }
    getBlock(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const { time, hash } = yield this.requestNode({
                url: `/v2/key-blocks/height/${height}`,
            }).then(({ data }) => data);
            return {
                height,
                time,
                hash,
            };
        });
    }
    getBlockchainHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = (yield this.requestNode({
                url: `/v2/key-blocks/current/height`,
            }));
            return data.height;
        });
    }
}
exports.default = AeternityService;
